import { Link } from "react-router-dom";
import {
  Building2,
  Landmark,
  Handshake,
  Receipt,
  BadgeCheck,
  CreditCard,
  Building,
  Users,
} from "lucide-react";
import useReveal from "../shared/useReveal";
import "./BusinessCards.css";
import "./HomeSections.css";

const CARDS = [
  {
    icon: Building2,
    title: "Company & LLP Registration",
    desc: "500+ incorporations — MCA filing, DIN/PAN/TAN, MOA & AOA drafting, post-registration GST/MSME/IEC.",
    href: "/business-services#formation",
  },
  {
    icon: Landmark,
    title: "Debt Funding",
    desc: "LAP, project & business finance, machinery loans — ₹200 Cr+ raised via banks & NBFCs.",
    href: "/business-services#debt",
  },
  {
    icon: Handshake,
    title: "Equity Funding",
    desc: "Seed to Series A — pitch decks, financial models, investor connects & term-sheet negotiation.",
    href: "/business-services#equity",
  },
  {
    icon: Receipt,
    title: "Accounting & Tax",
    desc: "Books, MIS, audits and proactive tax planning — investor-ready numbers.",
    href: "/business-services#accounting",
  },
  {
    icon: BadgeCheck,
    title: "Govt Schemes & Subsidies",
    desc: "Startup India, MSME, Mudra, CLCSS & sector incentives — eligibility to disbursement.",
    href: "/business-services#schemes",
  },
  {
    icon: CreditCard,
    title: "Business Loans",
    desc: "Working capital, term loans and machinery finance at the right rates.",
    href: "/business-services#debt",
  },
  {
    icon: Building,
    title: "NBFC Services",
    desc: "Licensing, operations and regulatory compliance for NBFCs.",
    href: "/business-services#nbfc",
  },
  {
    icon: Users,
    title: "Cooperative Banking",
    desc: "Advisory & compliance for cooperative credit institutions.",
    href: "/business-services#cooperative",
  },
];

export default function BusinessCards() {
  const ref = useReveal();

  return (
    <section className="section alt" id="business">
      <div className="container" ref={ref}>
        <div className="home-section-head section-head pm-reveal">
          <span className="kicker">For Startups & SMEs</span>
          <h2>Your business&apos;s entire finance office. Outsourced.</h2>
          <p className="sub">
            From incorporation to your first ₹10 Cr raise — a CA + CS team that
            has incorporated 500+ companies and raised ₹200 Cr+ in debt.
          </p>
        </div>
        <div className="home-prod-cards pm-stagger">
          {CARDS.map(({ icon: Icon, title, desc, href }) => (
            <Link key={title} to={href} className="home-pcard pm-reveal">
              <div className="pi">
                <Icon size={22} strokeWidth={2} />
              </div>
              <h3>{title}</h3>
              <p>{desc}</p>
              <span className="go">Explore →</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
